import { Button } from "@mui/material";
import { Slider } from "component/commonComponents/Slider";
import Box from "component/layoutComponents/Box/Box";
import styled from "styled-components";
import Typography from 'component/commonComponents/Typography/Typography';

export const StyledCategoryList = styled(Box)(({ theme }) => `
  padding: ${theme.uptimeSpace[8]}px;
  background: #F5F5FF;
  border-radius: 16px;
  padding-bottom: ${theme.uptimeSpace[16]}px;
`);

export const StyledItem = styled(Box)(({ theme }) => `
  padding: ${theme.uptimeSpace[8]}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;

  &:hover {
    background-color: ${theme.uptimeColors.grayScales.white};
    border-radius: 8px;
    box-shadow: 4px 10px 30px 4px rgba(36, 14, 47, 0.06);
    transition: 0.25s linear;
  }

  & > div {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 ${theme.uptimeSpace[8]}px;

    img {
      width: 100%;
      object-fit: contain;
      height: 100%
    }
  }

  p {
    height: 48px;
    margin-top: ${theme.uptimeSpace[5]}px;
    font-size: ${theme.uptimeFontSizes.desktop.fz5}px;
    font-weight: 600;
    text-align: center;
    @media (min-width: ${theme.breakpoints.md}) {
      height: 60px;
    }
  }
`);

export const ArrowButton = styled(Button)(({ theme }) => {
  const BUTTON_SIZE = 17;
  return {
    '&.MuiButton-root': {
      width: BUTTON_SIZE,
      height: BUTTON_SIZE,
      minWidth: 'unset',
      minHeight: 'unset',
      borderRadius: '50%',
      backgroundColor: theme.uptimeColors.deviceCardEyebrow.inUse.background,
      color: theme.uptimeColors.deviceCardEyebrow.inUse.color,
      
      '&:disabled': {
        backgroundColor: theme.uptimeColors.grayScales.lightGray,
      },

      '& > *': {
        width: BUTTON_SIZE,
        height: BUTTON_SIZE,
      },
    },
  };
});

export const StyledSlider = styled(Slider)(({ theme }) => `
  .slick-slide {
    & > div {
      display: flex;
      align-items: stretch;
    }
  }
`);

export const StyledDots = styled.ul`
  & li.slick-active p {
    opacity: 0.75;
  }
`;

export const StyledDot = styled(Typography)(
  ({ theme }) => `
  color: ${theme.uptimeColors.grayScales.black};
  padding: 5px;
  cursor: pointer;
  font-family: slick !important;
  font-size: 6px !important;
  line-height: 10px !important;
  opacity: 0.25;
  text-align: center;
  &:hover {
    opacity: 1;
  }`,
);